import { useHistory, useLocation } from 'react-router';
import arrowLeftIcon from '../../constants/icons/arrow_left_icon.png';
import arrowRightIcon from '../../constants/icons/arrow_right_icon.png';

interface IProps {
  activeGameId: number;
}

const DBetGameNavigate: React.FC<IProps> = ({ activeGameId }: IProps) => {
  // redirect functions
  const location = useLocation();
  const path = Number(location.pathname.split('/')[2]);
  const history = useHistory();

  const nextGame = () => history.push(`/dbetgame/${path + 1}`);
  const prevGame = () => history.push(`/dbetgame/${path - 1}`);
  const giveError = () => window.alert('Game ID out of bounds.');

  return (
    <>
      <div
        className="dbetGameNavigateIconContainer dbetGameNavigateIconContainerLeft"
        onClick={path > activeGameId - 5 ? prevGame : giveError}
      >
        <img
          src={arrowLeftIcon}
          alt="arrowLeftIcon"
          className="dbetGameNavigateIcon"
        />
      </div>
      <div
        className="dbetGameNavigateIconContainer dbetGameNavigateIconContainerRight"
        onClick={path < activeGameId + 5 ? nextGame : giveError}
      >
        <img
          src={arrowRightIcon}
          alt="arrowLeftIcon"
          className="dbetGameNavigateIcon"
        />
      </div>
    </>
  );
};

export default DBetGameNavigate;
